import React from 'react';
import { motion } from 'framer-motion';
export function ComparisonTable() {
  const rows = [{
    sit: 'Planificación semanal',
    sin: 'Horas buscando ejercicios en internet',
    con: '5 minutos. Todo listo.'
  }, {
    sit: 'Ejercicios',
    sin: 'Improvisados sin progresión clara',
    con: '+200 ejercicios graficados por categoría'
  }, {
    sit: 'Grupos mezclados',
    sin: 'Sin sistema claro para manejarlos',
    con: 'Estructura clara para cada nivel'
  }, {
    sit: 'Día de lluvia',
    sin: 'Cancelar y perder el ingreso',
    con: '10 clases bajo techo listas'
  }, {
    sit: 'Categoría',
    sin: 'Sin criterio técnico real',
    con: 'Nivelómetro con A/B/C tests graficados'
  }, {
    sit: 'Cuando el ejercicio no funciona',
    sin: 'Improvisar en el momento',
    con: '5 Salvavidas en 15 minutos'
  }];
  return <section className="bg-[#F3F4F6] py-20 px-4" data-id="element-43">
      <div className="max-w-5xl mx-auto" data-id="element-44">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold text-[#0284C7] text-center mb-12 uppercase tracking-wide" data-id="element-45">
          ¿Cuánto cuesta NO tenerlo?
        </motion.h2>

        {/* Desktop Table */}
        <div className="hidden md:block bg-white rounded-2xl shadow-lg overflow-hidden mb-12" data-id="element-46">
          <div className="grid grid-cols-3 bg-[#0284C7] text-white font-bold text-lg" data-id="element-47">
            <div className="p-6 text-center border-r border-white/20" data-id="element-48">
              Situación
            </div>
            <div className="p-6 text-center border-r border-white/20" data-id="element-49">
              Sin HOCKEY 360
            </div>
            <div className="p-6 text-center" data-id="element-50">Con HOCKEY 360</div>
          </div>

          {rows.map((row, i) => <div key={i} className={`grid grid-cols-3 ${i % 2 === 0 ? 'bg-white' : 'bg-[#F3F4F6]'} border-b border-gray-200 last:border-0`} data-id="element-51">
              <div className="p-6 flex items-center justify-center text-center font-bold text-gray-800 border-r border-gray-200" data-id="element-52">
                {row.sit}
              </div>
              <div className="p-6 flex items-center justify-center text-center text-red-600 font-medium border-r border-gray-200" data-id="element-53">
                <span className="mr-2" data-id="element-54">❌</span> {row.sin}
              </div>
              <div className="p-6 flex items-center justify-center text-center text-sky-700 font-bold" data-id="element-55">
                <span className="mr-2" data-id="element-56">✅</span> {row.con}
              </div>
            </div>)}
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden space-y-6 mb-12" data-id="element-57">
          {rows.map((row, i) => <div key={i} className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-58">
              <div className="bg-[#0284C7] text-white font-bold p-4 text-center" data-id="element-59">
                {row.sit}
              </div>
              <div className="p-4 border-b border-gray-100 bg-red-50" data-id="element-60">
                <div className="text-xs text-red-800 font-bold uppercase mb-1" data-id="element-61">
                  Sin HOCKEY 360
                </div>
                <div className="text-red-600 font-medium flex items-start gap-2" data-id="element-62">
                  <span data-id="element-63">❌</span> {row.sin}
                </div>
              </div>
              <div className="p-4 bg-sky-50" data-id="element-64">
                <div className="text-xs text-sky-800 font-bold uppercase mb-1" data-id="element-65">
                  Con HOCKEY 360
                </div>
                <div className="text-sky-700 font-bold flex items-start gap-2" data-id="element-66">
                  <span data-id="element-67">✅</span> {row.con}
                </div>
              </div>
            </div>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-bold text-center text-gray-900 uppercase tracking-wide" data-id="element-68">
          El lunes podés improvisar o entrar con todo resuelto. Vos decidís.
        </motion.p>
      </div>
    </section>;
}